import { usePreviewInlineEdit } from '@/storefront/context/PreviewInlineEditContext'
import { usePreviewMode } from '@/storefront/context/PreviewModeContext'

/**
 * True inside the theme editor (inline patch API) or template gallery preview (`PreviewModeProvider`).
 * Live customer-facing storefront: both are false.
 */
export function useStorefrontEditorSurface(): boolean {
  const inline = usePreviewInlineEdit()
  const isPreviewMode = usePreviewMode()
  return inline != null || isPreviewMode
}
